<template>
  <div class="donation">
    <PageBanner />
    <Breadcrumbs />

    <section class="content">
      <div class="container">
        <ul class="sitemap">
          <li
            v-for="(level1, index) in sitemap"
            :key="index"
          ><a
              :href="level1.path"
              v-html="level1.title"
            ></a>
            <ul v-if="level1.below">
              <li
                v-for="(level2, index) in level1.below"
                :key="index"
              >
                <a
                  :href="level1.path+level2.path"
                  v-html="level2.title"
                ></a>
                <ul v-if="level2.below">
                  <li
                    v-for="(level3, index) in level2.below"
                    :key="index"
                  >
                    <a
                      :href="level1.path+level2.path+level3.path"
                      v-html="level3.title"
                    ></a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
  import PageBanner from "@/components/pageBanner.vue";
  import Breadcrumbs from "@/components/breadcrumbs.vue";
  import navigationData from "@/assets/data/navigation.json";
  export default {
    name: "Sitemap",
    data() {
      return {
        sitemap: navigationData
      };
    },
    components: {
      PageBanner,
      Breadcrumbs
    }
  };
</script>